import Vue from 'vue'
import Router from 'vue-router'
import $store from '@/store.js'
import Bus from '@/assets/js/vueBus.js'

// 按需加载书写形式
const Playout = () =>
  import('@/views/Playout')
const PlayoutPlus = () =>
  import('@/views/PlayoutPlus')
Vue.use(Router)
const routes = [{
  path: '/',
  redirect: '/po'
},
{
  path: '/po',
  name: 'Playout',
  component: Playout,
  meta: {
    title: 'TPlayout'
  }
},
// 空白页面
{
  path: '/kb',
  name: 'noAuthority',
  component: () =>
    import('@/views/noAuthority'),
  meta: {
    title: 'TPlayout'
  }
}
]
const router = new Router({
  routes,
  linkExactActiveClass: 'tabActive'
})
router.beforeEach((to, from, next) => {
  // if (typeof SM == 'object') {
  //   typeof SM.closeShareBox == 'function' && SM.closeShareBox()
  // }
  // if ($('.mediaDialog').length > 0 && $('#dialogBg').length > 0) {
  //   $('#dialogBg').remove()
  //   $('.mediaDialog').remove()
  // }
  $store.dispatch('common/baseUrl')
  if (to.path != '/po') {
    router.push({
      path: '/po'
    })
  } else {
    next()
  }
})
export default router
